const initialState = {
  params: {
    groupTrainingSelect: null,
    userSelect: null,
    checkinStatus: null,
  },
  groupTrainingOptionSelect: null,
  userOptionSelect: null,
  checkinStatusOptionSelect: null,
  activitiesBeans: [],
  activitiesDate: null,
  userId: null,
  courseName: null,
  userDataList: null,
  courseId: null,
  activitiesId: null,
  activitiesDetailId: null,
  allCheckin: 0,
  checkin: 0,
  notCheckin: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "API_MONITOR_CHECKIN_GET_CRITERIA_SEARCH":
      return {
        ...state,
        groupTrainingOptionSelect: action.data.groupTrainingOptionSelect,
        userOptionSelect: action.data.userOptionSelect,
        checkinStatusOptionSelect: action.data.checkinStatusOptionSelect,
      };
    case "API_MONITOR_CHECKIN_GET_CHECKIN":
      return {
        ...state,
        userId: action.userId,
        activitiesDate: action.activitiesDate,
        checkin: action.data.checkin,
        allCheckin: action.data.allCheckin,
        courseName: action.data.courseName,
        activitiesBeans: action.data.activitiesBeans,
      };
    case "API_MONITOR_CHECKIN_SEARCH":
      return {
        ...state,
        userDataList: action.data.userDataList,
        allCheckin: action.data.allCheckin,
        checkin: action.data.checkin,
        notCheckin: action.data.notCheckin,
        courseId: action.courseId,
        activitiesDate: action.activitiesDate,
        activitiesId: action.activitiesId,
        activitiesDetailId: action.activitiesDetailId,
        params: {
          groupTrainingSelect: action.groupTrainingSelect,
          userSelect: action.userSelect,
          checkinStatus: action.checkinStatus,
        },
      };
    default:
      return state;
  }
};

export default reducer;
